export const JsonAppNames  = {
    FRAMEWORK :'frameWork',
    ACCOUNTANT :'accountant',
    PROPOSALS :'proposals',
    AUDITS :'audits',
    KNOWLEDGESHARE: 'knowledgeshare',
    LICENSURE :'lm',
    FIXUNCAT :'fix-uncat',
    BDIRECTORY :'bussDirectory',
    VCPORTAL :'vcPortal',
    CRM :'crm',
    EMAILREAD :'emailRead',
    EMAILCAMPAIGN :'emailCampaign',
    DYNAMICFORMS :'dynamicforms',
    BEANADVISOR :'beanadvisor',
    JOBS :'jobs',
    OM :'om',
    UTILITIES :'utilities'
}